import { APP_SLUG } from "./global";
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const APP_API_URL =  process.env.REACT_APP_API_URL;
export const AUTH_SIGN_IN_URL = `${AUTH_URL}connect/${APP_SLUG}`;

// process.env.REACT_APP_API_URL;
// export const AUTH_API_URL = "";
// export const AUTH_URL = "";
// export const APP_API_URL = "";
//export const AUTH_SIGN_IN_URL = `${AUTH_URL}connect/${APP_SLUG}`;